import * as React from 'react';
import { accentUtils } from '../../services/HelperService';
import { AccentNumberUnbound } from '../unbound/AccentNumberUnbound';
import { ConfiguratorContext } from './ConfigContextProvider';
import { isReadOnly, onSimpleOptionValueChanged, fromInt, useValidation, getOptionModel, configEventControlType, configEvents, useRefreshKey } from './ProductConfiguratorShared';

export const ConfigNumeric = props => {

    const focusBug = React.useRef(false);
    const ctx = React.useContext(ConfiguratorContext)
    const optionModel = getOptionModel(ctx, props.optionID);

    
    
    const validation = useValidation(props.optionID, "ConfigNumeric");

    const [value, setValue] = React.useState(accentUtils.isEmpty(optionModel.CurrentValueAsString) ? null : Number(optionModel.CurrentValueAsString));

    const refreshKey = useRefreshKey(props.optionID, value);

    const fireChange = React.useMemo(() => onSimpleOptionValueChanged(), [props.optionID]);


    const onChange = React.useCallback(e => {
        focusBug.current = false;
        fireChange(ctx, optionModel, e).then(() => {
            ctx.config?.Publish(configEvents.controlLostFocus, configEventControlType.numeric);
        });

        setValue(e);

    }, [setValue, ctx, optionModel, fireChange]);

    const onFocus = React.useCallback(e => {

        if (!focusBug.current) {
            focusBug.current = true;
            ctx.config?.Publish(configEvents.controlGotFocus, configEventControlType.numeric);
        }        

    }, [ctx]);

    const notifyDirty = React.useCallback(e => {

        if (ctx.notifyDirty) {
            ctx.notifyDirty();
        }

    }, [ctx]);


    const readOnly = isReadOnly(optionModel);

    const min = fromInt(optionModel.MinValue);
    const max = fromInt(optionModel.MaxValue);

    console.log(`optionID: ${props.optionID}...refreshKey: ${refreshKey.refreshID}...defaultValue: ${optionModel.CurrentValueAsString}`);


    return <div className="config-control config-numeric">
        <AccentNumberUnbound
            key={refreshKey.refreshID}
            required={ validation.required}
            defaultValue={accentUtils.isEmpty(optionModel.CurrentValueAsString) ? null : Number(optionModel.CurrentValueAsString)}
            onBlur={onChange}
            onFocus={onFocus}
            onChange={notifyDirty}
            isInt
            disabled={readOnly}
            min={min}
            max={max === 0 ? undefined : max}
            debounceMilliseconds={50}
        />
    </div>;
};